import { Text2GivePhoneNumber } from "../../types"
import { usePaymentMethodsContext } from "../../hooks/usePaymentMethodsContext"
import { Link } from "react-router-dom"
import { useGivingOrganizationContext } from "../../hooks/useGivingOrganizationContext"
import { useGivingPersonContext } from "../../hooks/useGivingPersonContext"

export default function Text2GiveNotActive() {
  const { givingOrganization } = useGivingOrganizationContext()
  const { paymentMethods } = usePaymentMethodsContext()
  const { givingPerson } = useGivingPersonContext()
  const text2GivePhoneNumber: Text2GivePhoneNumber =
    givingPerson.text_to_give_phone_number!

  const selectedPaymentMethod =
    (text2GivePhoneNumber.payment_method_id &&
      paymentMethods?.find(
        (paymentMethod) =>
          paymentMethod.id === text2GivePhoneNumber.payment_method_id,
      )) ||
    null

  return (
    <>
      <div className="d-b mb-2">
        {!givingOrganization.text2give_enabled ? (
          <p className="mb-1">
            {givingOrganization.name} no longer accepts gifts given via text
            message. You can <Link to={"/giving"}>give in Church Center</Link>.
          </p>
        ) : (
          <p className="mb-1">
            Text2Give is no longer supported via 84321. You can{" "}
            <Link to={"/giving"}>give to {givingOrganization.name}</Link> in
            Church Center.
          </p>
        )}
      </div>

      <div className="action-drawer">
        <dl>
          <div className="mb-2">
            <dt className="fs-4 c-tint2">Phone number:</dt>
            <dd className="fs-3 fw-600 c-tint1">
              {text2GivePhoneNumber.phone_number}
            </dd>
          </div>
          <div>
            <dt className="fs-4 c-tint2">Text2Give payment method:</dt>
            <dd className="fs-3 fw-600 c-tint1">
              {selectedPaymentMethod
                ? `${selectedPaymentMethod.brand} ... ${selectedPaymentMethod.last4}`
                : "None selected"}
            </dd>
          </div>
        </dl>
      </div>
    </>
  )
}
